import { MessageCircle } from "lucide-react";

const HELPLINE = "919015334444"; // OCTA helpline (E.164 without '+')

const clean = (num) => (num || "").toString().replace(/\D/g, "");

const toE164 = (raw) => {
  const digits = clean(raw);
  if (!digits) return HELPLINE;
  if (digits.startsWith("91") && digits.length === 12) return digits;
  if (digits.length === 10) return `91${digits}`;
  return digits;
};

export const waLink = (phone, text) => {
  const to = toE164(phone);
  const q = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${to}${q}`;
};

export default function WhatsAppButton({
  phone,
  text = "",
  label = "WhatsApp",
  variant = "primary", // 'primary' | 'ghost' | 'floating'
  size = "sm",
  className = "",
  testId,
}) {
  const href = waLink(phone, text);

  const base = "inline-flex items-center gap-2 font-semibold transition-colors";
  const sizes = {
    sm: "h-9 px-3 text-xs rounded-full",
    md: "h-10 px-4 text-sm rounded-full",
    lg: "h-12 px-6 text-sm rounded-full",
  };
  const variants = {
    primary: "bg-[#25D366] text-white hover:bg-[#1EBE5C]",
    ghost: "border border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10",
    floating:
      "fixed bottom-6 right-6 z-40 shadow-xl bg-[#25D366] text-white hover:bg-[#1EBE5C] h-14 w-14 !p-0 justify-center rounded-full",
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${variant === "floating" ? variants.floating : `${sizes[size]} ${variants[variant]}`} ${className}`}
      data-testid={testId || "whatsapp-btn"}
    >
      <MessageCircle className={variant === "floating" ? "w-6 h-6" : "w-4 h-4"} />
      {variant !== "floating" && label}
    </a>
  );
}
